import { ABP } from '@abp/ng.core';
import { TerminalManagement, AppModuleManagement } from '../models';

export class Register {
    static readonly type = '[TerminalManagement] register';
    constructor(public payload: TerminalManagement.RegisterRequest) { }
}

export class UpdateTerminal {
    static readonly type = '[TerminalManagement] update terminal';
    constructor(public payload: TerminalManagement.UpdateTerminalRequest) {

    }
}

export class EnableTerminal {
    static readonly type = '[TerminalManagement] enable terminal';
    constructor(public machineCode: string, public tenantId: string) {

    }
}

export class DisableTerminal {
    static readonly type = '[TerminalManagement] disable terminal';
    constructor(public machineCode: string, public tenantId: string) {

    }
}

export class DeleteTerminal {
    static readonly type = '[TerminalManagement] delete terminal';
    constructor(public id: string) {

    }
}

export class GetTerminal {
    static readonly type = '[TerminalManagement] get terminal';
    constructor(public id: string) {

    }
}

export class GetListTerminal {
    static readonly type = '[TerminalManagement] getlist terminal';
    constructor(public payload: TerminalManagement.GetTerminalsRequest) {

    }
}

export class BindAppModules {
    static readonly type = '[TerminalManagement] bind app-modules';
    constructor(public payload: AppModuleManagement.BindModulesRequest) {

    }
}

export class UnBindAppModules {
    static readonly type = '[TerminalManagement] unbind app-modules';
    constructor(public payload: AppModuleManagement.BindModulesRequest) {

    }
}

export class BindUsers {
    static readonly type = '[TerminalManagement] bind users';
    constructor(public payload: AppModuleManagement.BindUsersRequest) {

    }
}

export class UnBindUsers {
    static readonly type = '[TerminalManagement] unbind users';
    constructor(public payload: AppModuleManagement.BindUsersRequest) {

    }
}

export class GetAppTerminalSettings {
    static readonly type = '[TerminalManagement] get app-terminal-settings';
    constructor(public terminalId: string) {

    }
}